<style src="./BottomWave.scss" lang="scss" scoped></style>

<template src="./BottomWave.html" />

<script>
export default {
  name: 'BottomWave',
};
</script>
